import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

export interface PasswordCredentials {
    password: string;
    token: string;
    locale: string;
    ondemandRequest: boolean;
}

@Injectable()
export class RecoverPasswordActions {
    static RECOVER_PASSWORD_REQUEST = '[Auth-Recover]: Submit email';
    static RECOVER_PASSWORD_REQUEST_COMPLETE = '[Auth-Recover]: Complete recovery request';
    static RECOVER_PASSWORD_REQUEST_FAILED = '[Auth-Recover]: Recovery request failed';
    static RECOVER_PASSWORD_RESET_STEP = '[Auth-Recover]: Reset recovery step';
    static RECOVER_PASSWORD_SET_STEP = '[Auth-Recover]: Set recovery step';

    static SET_NEW_PASSWORD = '[Auth-Recover]: Set new password';
    static SET_NEW_PASSWORD_SUCCESS = '[Auth-Recover]: Set new password successful';
    static SET_NEW_PASSWORD_WITHOUT_LOGIN_SUCCESS = '[Auth-Recover]: Set new password without login successful';

    recoverPasswordRequest(payload: { email: string; locale: string; callback: string }): RidangoReduxAction {
        return {
            type: RecoverPasswordActions.RECOVER_PASSWORD_REQUEST,
            payload: payload
        };
    }

    recoverPasswordRequestComplete(): RidangoReduxAction {
        return {
            type: RecoverPasswordActions.RECOVER_PASSWORD_REQUEST_COMPLETE
        };
    }

    recoverPasswordRequestFailed(error: any): RidangoReduxAction {
        return {
            type: RecoverPasswordActions.RECOVER_PASSWORD_REQUEST_FAILED,
            payload: error
        };
    }

    recoverPasswordResetStep(): RidangoReduxAction {
        return {
            type: RecoverPasswordActions.RECOVER_PASSWORD_RESET_STEP
        };
    }

    recoverPasswordSetStep(step: number): RidangoReduxAction {
        return {
            type: RecoverPasswordActions.RECOVER_PASSWORD_SET_STEP,
            payload: step
        };
    }

    setNewPassword(payload: PasswordCredentials): RidangoReduxAction {
        return {
            type: RecoverPasswordActions.SET_NEW_PASSWORD,
            payload: payload
        };
    }

    setNewPasswordWithoutLoginSuccess(): RidangoReduxAction {
        return {
            type: RecoverPasswordActions.SET_NEW_PASSWORD_WITHOUT_LOGIN_SUCCESS
        };
    }

    setNewPasswordSuccess(token: string, ondemandRequest: boolean): RidangoReduxAction {
        return {
            type: RecoverPasswordActions.SET_NEW_PASSWORD_SUCCESS,
            payload: { token, ondemandRequest }
        };
    }
}
